import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError, tokenStore } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    if (!tokenStore.get()) {
      setUser(false);
      setChecked(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      tokenStore.clear();
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (username, password) => {
    try {
      const { data } = await api.post("/auth/login", { username, password });
      if (data.token) tokenStore.set(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      if (e.response?.data?.detail) {
        return { ok: false, error: formatApiError(e.response.data.detail) };
      }
      if (e.response) {
        return { ok: false, error: `Login failed (${e.response.status}). Please try again.` };
      }
      return { ok: false, error: "Cannot reach the server. Check your connection and try again." };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    tokenStore.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
